var $c804eeeafa73f9fb$exports = {};
$c804eeeafa73f9fb$exports = {
    "more": `\u{5E4}\u{5E8}\u{5D9}\u{5D8}\u{5D9}\u{5DD} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D9}\u{5DD}`
};


export {$c804eeeafa73f9fb$exports as default};
//# sourceMappingURL=he-IL.mjs.map
